<template>
    <div v-if="fields">

        <default-modal :showDialog="modals" :advertise="advertise"></default-modal>

        <uniq-modal v-if="type!=='default'" :showDialog="modals" :advertise="advertise"></uniq-modal>

        <div class="col-md-8 mx-auto py-0 my-0" v-for="item in properties" :key="item.label" :data-name="item.label">
            <component
                    :key="item.name"
                    :is="item.name === 'transformable_price' ? 'forRent' :item.component "
                    item-value="key"
                    item-text="lable"
                    :items="item.items"
                    :counter="enableCounter(item.name)"
                    :value="item.value"
                    :hint="item.hint"
                    @keypress="allowOnlyNumbers($event,item.name,item.type)"
                    :max="item.counter"
                    :maxLength="item.max"
                    rows="13"
                    :min="item.min"
                    :label="item.label"
                    oninput="if(Number(this.value) > Number(this.max) && this.type === 'number') this.value = this.max"
                    @input="getValue(item.label,$event,item.name,item.type)"
                    outlined
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    small-chips
                    :required="item.required"
                    :rules="item.rules"
                    :append-outer-icon="item.icons[2].icon"
                    :prepend-inner-icon="item.icons[0].icon"
                    @click:prepend-inner="item.icons[0].click"
                    @click:append-outer="item.icons[2].click"
                    :append-icon="item.icons[1].icon"
                    @click:append="item.icons[1].click"
                    @change="reload(item.autoReload,$event,item.name,item.type)"
                    :type="item.type"
                    :loading="loading"
                    :error-messages="item.errorMessage"
                    :name="item.name"
                    :placeholder="item.placeholder"
                    :multiple="item.name === 'colored_parts' "
                    dense>
            </component>

            <v-sheet v-if="titleEmoji === true && item.name === 'title' " class="mb-1" color="white lighten-3" outlined rounded>
                <v-card-text class="py-0 my-0" style="background-color: rgba(255,255,255,0.45)">
                    <button type="button" v-for="item in titleEmojis"
                            class="btn my-1  align-content-center py-1"
                            @click="titleEmojiPicker"
                            :data-emoji="item">{{ item }}
                    </button>
                </v-card-text>
                <v-btn color="error" text @click="titleEmoji = false"><i class="fa fa-times text-danger"></i></v-btn>
            </v-sheet>

            <v-sheet v-if="descriptionEmoji === true && item.name === 'description' " class="mb-1" color="white lighten-3" outlined rounded>
                <v-card-text class="py-0 my-0" style="background-color: rgba(255,255,255,0.45)">
                    <button type="button" v-for="item in descEmojis"
                            class="btn my-1  align-content-center py-1"
                            @click="descriptionEmojiPicker"
                            :data-emoji="item">{{ item }}
                    </button>
                </v-card-text>
                <v-btn color="error" text @click="descriptionEmoji = false"><i class="fa fa-times text-danger"></i></v-btn>
            </v-sheet>
        </div>
    </div>
</template>

<script>
import {VAutocomplete, VSelect, VSwitch, VTextarea, VTextField} from "vuetify/lib/components";
import UniqModal from "./UniqModal";
import DefaultModal from "./DefaultModal";

export default {
    name: "Inputs",
    components: {DefaultModal, UniqModal},
    props: {
        fields: {
            require: true,
        },
        advertise: {
            type: Object,
            require: true
        },
        type: {
            required: true,
            default: "advertise"
        }
    },
    data() {
        return {
            inputs: {
                "radio": VSelect,
                "string": VTextField,
                "TextFieldWidget": VTextField,
                "number": VTextField,
                "hierarchy_widget": VSelect,
                "SingleSelectHierarchyWidget": VSelect,
                "select": VAutocomplete,
                "textarea": VTextarea,
                "boolean": VSwitch,
                // "hidden": VHidden,
                "array": VAutocomplete,
                "object": VAutocomplete,
                "checkboxes": VAutocomplete
            },
            icons: [
                'mdi-emoticon',
                'mdi-emoticon-angry',
                'mdi-emoticon-excited',
            ],
            iconIndex: 0,
            titleEmojis: [
                "%",
                "٪",
                "*",
                "×",
                "،",
                ".",
                "-",
                "+",
                "«",
                "»",
                "&",
                "'",
                "(",
                ")",
                "/"
            ],
            descEmojis: [
                "✌️",
                "✅",
                "♻️",
                "❎",
                "✳️",
                "❇️",
                "✔️",
                "☑️",
                "⚫",
                "⚪",
                "▪️",
                "▫️",
                "◾",
                "◽",
                "◼️",
                "◻️",
                "⬛",
                "⬜",
                "♾️",
                "✖️",
                "➗",
                "➖",
                "➕",
                "↩️",
                "↪️",
                "⤵️",
                "⤴️",
                "↔️",
                "↕️",
                "↖️",
                "↙️",
                "↘️",
                "↗️",
                "⬇️",
                "⬆️",
                "⬅️",
                "➡️",
                "◀️",
                "⏬",
                "⏫",
                "⏪",
                "⏩",
                "*️⃣",
                "#️⃣"
            ],
            singleFiltered: {
                "contact": null,
                "zoonkan_enabled": null,
                "category": null,
                "secure_call_more_info": null,
                "location": null,
                "optional_fields_description_section": null,
                "other_options_and_attributes": null,
                "images": null,
                "call_method": null,
                "hide_phone": null,
                "chat_enabled": null,
                "phone": null,
                "force_chat_enabled": null
            },
            titleEmoji: false,
            descriptionEmoji: false,
            loading: false,
            modals: {
                default: false,
                unique: false
            }
        }
    },
    methods: {
        getProperty(key) {
            const name = key.name;
            const min = key.min
            const max = key.max;
            const help = key.placeholder;
            const requireField = key.required;
            const placeholder = key.placeholder;
            const autoReload = key.auto_refresh;
            const has_field = key.fields
            let items = [];
            let type = key.field_type !== null ? key.field_type : (key.type !== 'integer' ? key.type : "number");
            let title = key.title;
            let itemValue = key.enum ?? [];
            let itemText = key.enumNames ?? itemValue;

            itemValue.forEach((item, index) => {
                items.push({
                    key: item,
                    lable: itemText[index]
                })
            })

            return {
                component: this.inputs[type],
                label: title,
                counter: max ? max : null,
                hint: help ? help : null,
                items: items,
                name: name,
                min: min,
                value: this.advertise[name] || "",
                required: requireField,
                placeholder: placeholder,
                has_fields: has_field,
                errorMessage: "",
                autoReload: autoReload,
                rules: [
                    (v) => {
                        if ((name === "title" || name === "description"))
                            return (this.required === true ? v < max : v.length <= max) || 'مقدار وارد شده بیش از حد مجاز است.حداکثر مقدار موردنیاز ' + max + ' است.';
                        else if (["boolean", "select", "string", "object", "number", "array", "hidden", "radio", "SingleSelectHierarchyWidget", "checkboxes", "hierarchy_widget"].indexOf(type) > -1)
                            return true;
                    },
                    (v) => {
                        if ((name === "title" || name === "description"))
                            return (this.required === true ? v > min : v.length >= min) || 'مقدار وارد شده کمتر از حد مجاز است.حداقل مقدار موردنیاز  ' + min + ' است.';
                        else if (["boolean", "select", "object", "string", "number", "array", "hidden", "number", "radio", "checkboxes", "hierarchy_widget"].indexOf(type) > -1)
                            return true;

                    },
                ],
                icons: [
                    {
                        icon: 'mdi-emoticon' ? title === 'عنوان آگهی' || title === 'توضیحات آگهی' ? this.icon : 'fas fa-pencil-alt' : this.icon,
                        click: () => {
                            if (title === 'عنوان آگهی')
                                this.titleEmoji = true;
                            else if (title === "توضیحات آگهی")
                                this.descriptionEmoji = true
                            else return false;
                        }
                    },
                    {
                        icon: 'mdi-emoticon' ? title === 'عنوان آگهی' || title === 'توضیحات آگهی' ? 'fa fa-edit' : '' : 'fa fa-edit',
                        click: () => {
                            if (title === 'عنوان آگهی') {
                                this.modals.default = true
                            } else if (title === 'توضیحات آگهی') {
                                this.modals.default = true
                            }
                        }
                    },
                    {
                        icon: 'mdi-emoticon' ? title === 'عنوان آگهی' ? 'fa fa-check' : '' : 'mdi-emoticon',
                        click: () => {
                            this.modals.unique = true;
                        }
                    },

                ],
                type: type,
            };
        },
        enableCounter(name) {
            if (name === "title") {
                return 50;
            } else if (name === "description") {
                return 1000;
            } else
                return false
        },
        allowOnlyNumbers(value, name, type) {
            if (type === 'number') {
                let allowedKeys = [8, 46, 38, 40, 37, 39];

                const keyPressed = value.which || value.keyCode;

                if (/[^0-9\s]+/.test(value.key)) {
                    if (allowedKeys.every(e => e !== keyPressed))
                        value.preventDefault();
                } else
                    return true
            }
        },
        getValue(title, value, name, type) {
            if (title === 'عنوان آگهی') {
                this.itemType = title;
                this.titleValue = value;
            } else if (title === 'توضیحات آگهی') {
                this.descriptionValue = value;
            }

            this.properties.find((x) => x.name === name).errorMessage = "";
        },
        reload(isAutoReload, value, name, type) {
            switch (type) {
                case "boolean":
                    const bol = Boolean(value);
                    if (bol)
                        this.advertise[name] = bol;
                    break;
                case "number":
                    this.advertise[name] = Number(value);
                    break;
                default:
                    this.advertise[name] = value;
                    break;
            }
        },
        validate() {
            if (this.current === '') {
                this.$modal.error('خطا!', 'لطفا دسته موردنظرتان را انتخاب کنید.');
                return false;
            }

            let validate = true;

            this.properties.filter((item) => item.required === true).forEach((item) => {
                if (this.advertise[item.name]) {
                    validate = validate && true;
                } else {
                    item.errorMessage = 'واردکردن فیلد ' + ' «' + item.label + '» ' + 'الزامی است.'
                    validate = false;
                }
            })

            return validate;
        },
        titleEmojiPicker(element) {
            const $title = $('[name = "title"]')[0];

            let currentInput = this.properties.find(item => item.name === "title").value;
            let cursorPos = $title.selectionStart;
            let textBefore = currentInput.substring(0, cursorPos);
            let textAfter = currentInput.substring(cursorPos, currentInput.length);

            currentInput = textBefore + $(element.target).data("emoji") + textAfter;
            this.advertise.title = currentInput;

            this.$nextTick(function () {
                $title.focus();
                $title.setSelectionRange(cursorPos, cursorPos);
            })
        },
        descriptionEmojiPicker(element) {
            const $title = $('[name = "description"]')[0];

            let currentInput = this.properties.find(item => item.name === "description").value;
            let cursorPos = $title.selectionStart;
            let textBefore = currentInput.substring(0, cursorPos);
            let textAfter = currentInput.substring(cursorPos, currentInput.length);

            currentInput = textBefore + $(element.target).data("emoji") + textAfter;
            this.advertise.description = currentInput;

            this.$nextTick(function () {
                $title.focus();
                $title.setSelectionRange(cursorPos, cursorPos);
            })
        },
    },
    computed: {
        properties() {
            let properties = [];

            this.fields.filter((x) => {
                if (Object.keys(this.singleFiltered).includes(x.name)) {
                    this.singleFiltered[x.name] = true;
                    return false;
                }
                return true;
            }).forEach((item) => {
                properties.push(this.getProperty(item));
            });

            return properties;
        },
        icon() {
            return this.icons[this.iconIndex]
        },
    },
}
</script>

<style scoped>

</style>